
  export default {
    props: {
      product: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        scrollPosition: 0,
        boxes: null,
        amountOfBoxes: 0,
        boxCircles: null,
        progressBar: null
      };
    },
    computed: {
      startScrollPosition: {
        get: function () {
          return document.querySelector('.outer-container') ? document.querySelector('.outer-container').offsetTop - 500 : 0;
        },
        set: function () {
        }
      }
    },
    watch: {
      product: 'loadLangFile'
    },
    created () {
      this.loadLangFile();
    },
    mounted () {
      window.addEventListener('scroll', this.scrollListener);

      // cache elements
      this.boxes = document.getElementsByClassName('box-container');
      this.amountOfBoxes = this.boxes.length;
      this.boxCircles = document.getElementsByClassName('box-circle');
      this.progressBar = document.querySelector('.progress-bar');
      if (this.progressBar) {
        this.progressBar.style.height = 0;
      }
    },
    beforeDestroy  () {
      this.startScrollPosition = 0;
      this.progressBar = null;
      window.removeEventListener('scroll', this.scrollListener);
    },
    methods: {
      async loadLangFile () {
        try {
          const lang = require(`@/lang/humanising/${this.product}.json`);
          this.$i18n.mergeLocaleMessage('en', lang.en);
        } catch (error) {
          console.error(`Failed to load humanising-${this.product}.json`, error);
        }
      },
      scrollListener: function () {
        this.scrollPosition = window.scrollY.toFixed(0);
        this.progressBar.style.height = this.scrollPosition - this.startScrollPosition + 'px';
        this.updateGreenCircle();
      },
      updateGreenCircle () {
        const boxHeight = [];
        const totalBoxHeight = [];
        totalBoxHeight[-1] = 0;
        for (let i = 0; i < this.amountOfBoxes; i++) {
          boxHeight[i] = this.boxes[i].offsetHeight + 50;
          totalBoxHeight[i] = totalBoxHeight[i - 1] + boxHeight[i];
          if (this.progressBar.offsetHeight >= 12) {
            this.boxCircles[0] && this.boxCircles[0].classList.add('progress-green');
          } else {
            this.boxCircles[0] && this.boxCircles[0].classList.remove('progress-green');
          }
          if (this.progressBar.offsetHeight >= (totalBoxHeight[i])) {
            this.boxCircles[i + 1] && this.boxCircles[i + 1].classList.add('progress-green');
          } else {
            this.boxCircles[i + 1] && this.boxCircles[i + 1].classList.remove('progress-green');
          }
        }
      }
    }
  };
